/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type EnvResponseDto = {
    /**
     * The NODE_ENV environment variable value
     */
    nodeEnv: EnvResponseDto.nodeEnv;
};
export namespace EnvResponseDto {
    /**
     * The NODE_ENV environment variable value
     */
    export enum nodeEnv {
        DEVELOPMENT = 'development',
        PRODUCTION = 'production',
        TEST = 'test',
        NOT_SET = 'not set',
    }
}

